// Calculate direction to Kaaba (Mecca)
export const calculateQiblaDirection = (latitude: number, longitude: number): number => {
  // Kaaba coordinates
  const kaabaLat = 21.4225;
  const kaabaLng = 39.8262;
  
  // Convert to radians
  const lat1 = latitude * (Math.PI / 180);
  const lng1 = longitude * (Math.PI / 180);
  const lat2 = kaabaLat * (Math.PI / 180);
  const lng2 = kaabaLng * (Math.PI / 180);
  
  // Calculate direction
  const y = Math.sin(lng2 - lng1) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);
  let bearing = Math.atan2(y, x);
  
  // Convert to degrees
  bearing = bearing * (180 / Math.PI);
  bearing = (bearing + 360) % 360;
  
  return bearing;
};

// Get cardinal direction based on degrees
export const getCardinalDirection = (angle: number | null): string => {
  if (angle === null) return 'N-E-S-W';
  const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return directions[Math.round(angle / 45) % 8];
};